import { Row } from 'react-table';
import { Header } from 'layout';
import { withPlaceholder } from 'HOC';
import { IraUser } from 'services/requests';
import { useRole } from 'hooks/common/useRole';
import { useGetEmployer } from 'hooks/api/employer';
import { useNavigate, useQueryParams } from 'hooks/routes';
import { useGetIraUsers, useGetIraUserPrefetch } from 'hooks/api/iraUser';
import { useSetData } from 'hooks/cache';
import { useModalState } from 'hooks/modals';
import { mapCustodianTypeKeyToValue } from 'utils';
import { Parameters } from 'constants/queryParameters';
import { QueryKeys } from 'constants/queryKeys';
import { PlusIcon_24 } from 'assets/icons';
import Button from 'components/Button';
import { IraUsersTableSign, mapData } from './IraUsersTable.columns';
import RenderTable from '../components/RenderTable';
import SpecifyEmail from '../components/SpecifyEmail';
import messages from './IraUsersTable.messages';
import styles from './IraUsersTable.module.css';

const RenderTablewithPlaceholders = withPlaceholder(RenderTable);

const IraUsersTable = (): JSX.Element => {
  const { isModalVisible, openModal, closeModal } = useModalState();
  const { isAdmin } = useRole();
  const { toEmployers, toIraUserRole } = useNavigate();

  const employerId = useQueryParams(Parameters.employerId);

  const { data: employerData } = useGetEmployer();
  const {
    data: iraUsersData,
    isLoading,
    isError,
    refetch,
    isRefetching,
  } = useGetIraUsers();
  const prefetch = useGetIraUserPrefetch();
  const addIraUserToCache = useSetData();

  const onEdit = (user: IraUser) => {
    toIraUserRole({ employerId, iraUserId: String(user.id) });
  };

  const items = mapData(iraUsersData?.items, onEdit, prefetch);

  const onNewEmployeeClick = (): void => {
    openModal();
  };

  const onIraUserClick = (row: Row<IraUsersTableSign>): void => {
    const iraUser = iraUsersData?.items[row.index];
    if (iraUser) {
      addIraUserToCache(
        { ...iraUser, custodianType: mapCustodianTypeKeyToValue(iraUser.custodianType) },
        QueryKeys.iraUser,
      );
    }
    toIraUserRole({ employerId, iraUserId: String(row.original.id) });
  };

  return (
    <>
      <Header
        title={employerData?.name ? employerData?.name : messages.title}
        complexComponent={isAdmin}
        contentClassName={styles.headerButtons}
      >
        <Button onClick={onNewEmployeeClick}>
          <PlusIcon_24 className={styles.plusIcon} />
          {messages.newEmployee}
        </Button>
      </Header>
      <SpecifyEmail onRequestClose={closeModal} isOpen={isModalVisible} />
      <RenderTablewithPlaceholders
        iraUsersData={iraUsersData}
        items={items}
        onIraUserClick={onIraUserClick}
        refetch={refetch}
        isRefetching={isRefetching}
        isLoading={isLoading}
        isError={isError}
        isData={!!iraUsersData?.context && !!items && items?.length !== 0}
      />
    </>
  );
};

export default IraUsersTable;
